export const THEMES = [
  { id: "forest-green-gold", name: "Forest Green & Gold", note: "Default", surface: "#ECE7D6", swatches: ["#1D512C", "#CC9933", "#78A34F", "#F5F4E9"] },
  { id: "midnight-navy-sage", name: "Midnight Navy & Sage", surface: "#172B44", swatches: ["#172B44", "#7FB7E0", "#7BA05B", "#F2F5F9"] },
  { id: "charcoal-ivory-gold", name: "Charcoal Ivory & Gold", surface: "#222A34", swatches: ["#222A34", "#D4A359", "#86AB5E", "#F9F8F3"] },
  { id: "espresso-taupe-olive", name: "Espresso Taupe & Olive", surface: "#DFD6C8", swatches: ["#3B2E25", "#A87A33", "#5E6B4E", "#F7F4EE"] },
  { id: "black-and-white", name: "Black & White", surface: "#FFFFFF", swatches: ["#111111", "#555555", "#D4D4D4", "#FAFAFA"] },
];

export const DEFAULT_THEME = "forest-green-gold";
export const logoSrc = (theme, mark = false, light = false) => `/brand/${theme}${mark ? "-mark" : light ? "-light" : ""}.png`;
